import { useSelector } from 'react-redux';
import { selectEquifaxDemoEnabled } from 'app/shared/featureFlags/selectors';
import Unit21Icon from 'app/shared/components/logos/icon.svg';
import { HTMLProps } from 'react';
import { getDOMProps } from 'app/shared/utils/react';
import EquifaxLogoIcon from 'app/shared/components/logos/equifaxLogoIcon.svg';

export const Unit21LogoIcon = (props: HTMLProps<SVGElement>) => {
  const equifaxDemoEnabled = useSelector(selectEquifaxDemoEnabled);
  if (equifaxDemoEnabled) {
    return <EquifaxLogoIcon alt="Logo small" {...getDOMProps(props)} />;
  }
  return <Unit21Icon alt="Logo small" {...getDOMProps(props)} />;
};
